<template>
    <x-data-table
        class="no-row-hover"
        :headers="entityTableHeaders"
        :items="value"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No data found</p>
        </template>
        <template v-slot:items="props">
            <tr>
                <td>
                    {{ props.item.entity.name }}
                </td>
                <td>
                    {{ (props.item.address) ? props.item.address.line1 : 'N/A' }}
                </td>
            </tr>
        </template>
    </x-data-table>
</template>

<script>

export default {
    name: 'SubmissionEntityDataList',
    props: {
        value: null
    },
    computed: {
        entityTableHeaders() {
            return [
                {
                    text: 'Entity',
                    value: 'value.entity.name'
                },
                {
                    text: 'Address',
                    value: 'value.address.line1'
                },
            ]
        }
    }
}
</script>
